import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import DeliveryMethods from './../block/DeliveryMethods'

import { Container, Image, Spinner, Button, Form, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      products: [],
      loyalty: {
        bonus: null,
        discount: null
      },
      count: 0,
      sortName: `Сначала дешевле`,
      payment: 1,
      delivery_method: 0,
      delivery_id: 0,
      delivery_adres: 0,
      delivery_price: 0,
      name: ``,
      phone: ``,
      email: ``,
      comment: ``,
      show: false,
      modal_text: ``,
      order_sent: false,
      giftcard: ``,
      giftcard_summ: 0,
      gk_sale: false
    }
  }

  setName( val ) {
    this.setState({
      name: val
    })
  }
  setPhone( val ) {
    this.setState({
      phone: val
    })
  }
  setEmail( val ) {
    this.setState({
      email: val
    })
  }
  setComment( val ) {
    this.setState({
      comment: val
    })
  }

  setDelivery = ( dmet, id, adres, price ) => {
    this.setState({
      delivery_method: dmet,
      delivery_id: id,
      delivery_adres: adres,
      delivery_price: Number( price )
    })
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) return 0
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  normalizeCountForm = (number, words_arr) => {
    number = Math.abs(number)
    if (Number.isInteger(number)) {
      let options = [2, 0, 1, 1, 1, 2]
      return words_arr[(number % 100 > 4 && number % 100 < 20) ? 2 : options[(number % 10 < 5) ? number % 10 : 5]]
    }
    return words_arr[1]
  }

  getCart() {
    const { cart, addTocart } = this.props

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'get_cart_data',
      'cart': JSON.stringify( cart ),
      'loyality': 1
    }).then( ( response ) => {
      var fined = false
      cart.map( ( product ) => {
        fined = false
        response.data.products.map( ( in_cart ) => {
          if( product.variant == null ) {
            if( product.product == in_cart.product ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: null,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          } else {
            if( product.product == in_cart.product && product.variant == in_cart.variant ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: product.variant,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          }
        } )
        if( !fined ) {
          addTocart({
            resource: product.resource,
            product: product.product,
            variant: product.variant,
            count: 0
          })
        }
      } )
      this.setState({
        loaded: true,
        products: response.data.products,
        count: response.data.count,
        sum: response.data.sum,
        loyalty: response.data.loyalty,
        giftcard: response.data?.giftcard || ``,
        giftcard_summ: response.data?.giftcard_summ,
        gk_sale: response.data?.gk_sale
      }, () => {
        if(response.data?.gk_sale) this.setState({
          payment: 2
        })
      })
    })
  }

  changeCount = ( product, count ) => {
    const { addTocart } = this.props,
    main = this

    addTocart({
      resource: product.res_id,
      product: product.product,
      variant: product.variant,
      count: count
    }, () => {
      main.getCart()
    })
  }

  getPointPrice = ( code ) => {
    window.console.log( code )
  }

  setPayment( payment ) {
    this.setState({
      payment: payment
    })
  }

  sendOrder = () => {
    const { name, phone, email, comment, delivery_method, delivery_id, delivery_adres, delivery_price, payment } = this.state,
    { cart, page_data, clearCart } = this.props

    if( name == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваше имя`
      })
      return
    }
    if( phone == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваш телефон`
      })
      return
    }
    if( email == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваш e-mail`
      })
      return
    }
    if( delivery_method == 0 ) {
      this.setState({
        show: true,
        modal_text: `Выберите способ доставки`
      })
      return
    }
    if( delivery_method == 3 ) {
      let adresArr = delivery_adres.split(','),
      moscow = false
      adresArr.map(( part ) => {
        if( part.trim() == 'москва' || part.trim() == 'Москва' ) moscow = true
      })
      if( !moscow ) {
        this.setState({
          show: true,
          modal_text: `Выберите способ доставки`
        })
        return
      }
    }
    if( delivery_adres.length < 3 && delivery_method in [ 3, 4 ] ) {
      this.setState({
        show: true,
        modal_text: `Ошибка: некоректный адрес доставки`
      })
      return
    }
    if (payment === 1 && [3, 4].includes(delivery_method)) {
      this.setState({
        show: true,
        modal_text: `Выберите способ оплаты`
      })
      return
    }
    if( payment == 0 ) {
      this.setState({
        show: true,
        modal_text: `Выберите способ оплаты`
      })
      return
    }

    this.setState({
      order_sent: true
    })

    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'send_order',
      'cart': JSON.stringify( cart ),
      'name': name,
      'phone': phone,
      'email': email,
      'delivery_method': delivery_method,
      'delivery_id': delivery_id,
      'delivery_adres': delivery_adres,
      'delivery_price': delivery_price,
      'payment': payment,
      'comment': comment
    }).then( ( response ) => {
      if( response.data.success ) {
        clearCart( () => {
          location.href = page_data.oformlen_link + `?order=` + response.data.data.msorder
        } )
      } else {
        if( 'message' in response.data ) {
          main.setState({
            show: true,
            modal_text: 'Ошибка: ' + response.data.message,
            order_sent: false
          })
        } else {
          main.setState({
            show: true,
            modal_text: 'Ошибка оформления заказа, попробуйте позже!',
            order_sent: false
          })
        }
      }
    })
  }

  handleClose() {
    this.setState({
      show: false
    })
  }

  setGiftcard = ( giftcard ) => {
    this.setState({
      giftcard: giftcard
    })
  }
  sendGiftcard = () => {
    const { giftcard } = this.state

    if( giftcard == `` ) {
      this.setState({
        show: true,
        modal_text: `Введите номер подарочной карты`
      })
      return
    }

    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'send_giftcard',
      'giftcard': giftcard
    }).then( ( response ) => {
      if(!response.data?.success) {
        main.setState({
          show: true,
          modal_text: response.data?.message
        })
      }
      main.getCart()
    })
  }

  componentDidMount() {
    this.getCart()
    if('user' in this.props.ajax_data) {
      if( this.props.ajax_data.user.authorized ) {
        this.setState({
          name: this.props.ajax_data.user.fullname,
          phone: this.props.ajax_data.user.mobilephone,
          email: this.props.ajax_data.user.email
        })
      }
    }
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart, changeFavorite } = this.props,
    { loaded, products, count, sum, delivery_price, payment, name, phone, email, comment, loyalty, show, modal_text, order_sent, giftcard, giftcard_summ, gk_sale, delivery_method } = this.state

    if(ajax_data != null) return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          {ajax_data != null &&
            <>
              <Breadcrumbs
                pages={[
                  {
                    name: `Корзина`,
                    url: page_data.cart_link,
                    current: false
                  },
                  {
                    name: ajax_data.pagetitle,
                    current: true
                  }
                ]}
              />
              <div className={styles.korzina}>
                <Container>
                  <div className='d-flex flex-column flex-xl-row align-items-start justify-content-between'>
                    <div className={styles.korzina_flex}>
                      <div>
                        <h1>{ajax_data.seo_h1}</h1>
                        <div className={styles.korzina_text}>
                          Мы сотрудничаем с надежными логистическими компаниями, чтобы обеспечить<br />
                          своевременную доставку заказов в любые регионы России<br /><br />
                          Обработка заказа начнется сразу после того, как мы подтвердим получение оплаты. Обычно это происходит в течение нескольких минут после совершения платежа.
                        </div>
                      </div>
                      {loaded ?
                        <>
                          {products.length > 0 ?
                            <Form className={styles.korzina_form}>
                              <div className={styles.korzina_form_title + ` d-flex align-items-end justify-content-between`}>
                                <div>Контактные данные</div>
                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11 6L6 1L1 6" stroke="black"/>
                                </svg>
                              </div>
                              <Form.Control name='name' onChange={( e ) => this.setName( e.target.value )} value={name} className={styles.korzina_form_input} type="text" placeholder="Ваше имя" />
                              <Form.Control name='phone' as={IMaskInput} mask="+{7} (000) 000-00-00" lazy={true} type="phone" onChange={( e ) => this.setPhone( e.target.value )} value={phone} className={styles.korzina_form_input} placeholder="Ваш телефон" autoComplete="new-password" />
                              <Form.Control name='email' onChange={( e ) => this.setEmail( e.target.value )} value={email} className={styles.korzina_form_input} type="email" placeholder="Ваше e-mail" />
                              <DeliveryMethods
                                ajax_data={ajax_data}
                                page_data={page_data}
                                priceFormat={this.priceFormat}
                                setDelivery={this.setDelivery}
                                delivery_price={delivery_price}
                                cart={cart}
                                sum={sum}
                              />
                              <div className={styles.korzina_form_title + ` d-flex align-items-end justify-content-between`}>
                                <div>Способы оплаты</div>
                                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11 6L6 1L1 6" stroke="black"/>
                                </svg>
                              </div>
                              <div className='d-flex align-items-center'>
                                {ajax_data.payments.map(( pel, k ) => {
                                  if(pel.id != 2 && gk_sale) return <></>
                                  if(pel.id == 4 && giftcard_summ > 0) return <></>
                                  if (pel.id === 1 && [3, 4].includes(delivery_method)) {
                                    return <></>
                                  }
                                  return (
                                    <div onClick={() => this.setPayment( pel.id )} key={k} className={styles.korzina_form_checkbox}>
                                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                                        {payment == pel.id &&
                                          <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                                        }
                                      </svg>
                                      <div className={styles.korzina_form_checkbox_name}>{pel.name}</div>
                                    </div>
                                  )
                                })}
                              </div>
                              <div className={styles.korzina_form_title_2}>Комментарий к заказу</div>
                              <Form.Control name='comment' onChange={( e ) => this.setComment( e.target.value )} value={comment} className={styles.korzina_form_textarea} as="textarea" rows={3} />
                            </Form>
                          :
                            <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                              <p>Добавьте товары в корзину</p>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                          <Spinner animation="grow" variant="dark" />
                        </div>
                      }
                    </div>
                    <div className={styles.korzina_rchast}>
                      <div className={styles.korzina_rchast_plashka}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className={styles.korzina_rchast_title}>ВАШ ЗАКАЗ</div>
                          <div className={styles.korzina_rchast_count}>{count} {this.normalizeCountForm( count, [ 'товар', 'товара', 'товаров' ] )}</div>
                        </div>
                        <div className={styles.korzina_rchast_text}>Доступные способы доставки можно выбрать при оформлении заказа</div>
                        {loaded &&
                          <>
                            {products.length > 0 &&
                              <>
                                <div className={styles.korzina_rchast_products}>
                                  {products.map( ( product, k ) => {
                                    return (
                                      <div className={styles.korzina_list_elm} key={k}>
                                        <div style={{ flex: 1 }} className='d-flex'>
                                          {product.image != null &&
                                            <a href={product.url}>
                                              <Image className={styles.korzina_list_elm_image} src={product.image} width="117" height="172" />
                                            </a>
                                          }
                                          <div className={styles.korzina_list_elm_content_rchast}>
                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                              <div className={styles.korzina_list_elm_art_rchast}>Арт. {product.article}</div>
                                              <div className={styles.korzina_list_elm_price_rchast + ` d-none d-sm-block`}>{this.priceFormat(product.price)} ₽</div>
                                            </div>
                                            <div className={styles.korzina_list_elm_name_rchast}>{product.name}</div>
                                            {product.size && <div className={styles.korzina_list_elm_option}>Размер: {product.size}</div>}
                                            {product.colorName && <div className={styles.korzina_list_elm_option_color}>
                                              Цвет: {product.colorName}
                                              <div className={styles.korzina_list_elm_option_color_dot}></div>
                                              <div style={{ backgroundColor: product.color }} className={styles.korzina_list_elm_option_color_color}></div>
                                            </div>}
                                            <div className={styles.korzina_list_elm_price_rchast + ` d-sm-none`}>{this.priceFormat(product.price)} ₽</div>
                                            <div style={{ flex: 1 }} className='d-flex flex-column w-100'>
                                              <div className='d-block' style={{ flex: 1 }}></div>
                                              <div className='d-flex align-items-end justify-content-between w-100'>
                                                <div className={styles.korzina_list_elm_btns + ` d-flex`}>
                                                  <svg onClick={() => changeFavorite( product.res_id )} width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 3.2002V12.6854C0 14.0464 0 14.7268 0.204119 15.1433C0.582446 15.9151 1.41157 16.3588 2.26367 16.2454C2.7234 16.1842 3.28964 15.8067 4.4221 15.0518L4.42481 15.0499C4.87368 14.7507 5.09815 14.6011 5.33295 14.5181C5.76421 14.3656 6.23476 14.3656 6.66602 14.5181C6.90129 14.6012 7.12664 14.7515 7.57732 15.0519C8.70978 15.8069 9.27665 16.1841 9.73638 16.2452C10.5885 16.3586 11.4176 15.9151 11.7959 15.1433C12 14.7269 12 14.0462 12 12.6854V3.19691C12 2.07899 12 1.5192 11.7822 1.0918C11.5905 0.715473 11.2837 0.409734 10.9074 0.217987C10.4796 0 9.9203 0 8.8002 0H3.2002C2.08009 0 1.51962 0 1.0918 0.217987C0.715473 0.409734 0.409734 0.715473 0.217987 1.0918C0 1.51962 0 2.08009 0 3.2002Z" fill={favorite.includes( product.res_id ) ? `#FF0000` : `#F6F6F6`}/>
                                                  </svg>
                                                  <svg onClick={() => this.changeCount( product, 0 )} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                                  </svg>
                                                </div>
                                                <div> </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                                <div className={styles.korzina_rchast_sep}></div>
                                <div className={styles.korzina_rchast_prices + ` w-100 d-flex align-items-center justify-content-between`}>
                                  <div>Стоимость доставки</div>
                                  <div>{this.priceFormat(delivery_price)} ₽</div>
                                </div>
                                {loyalty.discount != null &&
                                  <>
                                    <div className={styles.korzina_rchast_prices + ` w-100 d-flex align-items-center justify-content-between`}>
                                      <div>Скидка (уровень лояльности {loyalty.discount.loyalty_level})</div>
                                      <div>{this.priceFormat(loyalty.discount.summ)} ₽</div>
                                    </div>
                                  </>
                                }
                                {giftcard_summ > 0 &&
                                  <>
                                    <div className={styles.korzina_rchast_prices + ` w-100 d-flex align-items-center justify-content-between`}>
                                      <div>Подарочная карта</div>
                                      <div>{this.priceFormat(giftcard_summ)} ₽</div>
                                    </div>
                                  </>
                                }
                              </>
                            }
                            <div className={styles.korzina_rchast_sep}></div>
                            {sum > 0 &&
                              <>
                                <div className={styles.korzina_rchast_sum}>
                                  <div>Итого:</div>
                                  {loyalty.discount != null ?
                                    <div>{delivery_price ? this.priceFormat( sum - loyalty.discount.summ - giftcard_summ + delivery_price ) : this.priceFormat( sum - giftcard_summ - loyalty.discount.summ )} ₽</div>
                                  :
                                    <div>{delivery_price ? this.priceFormat( sum - giftcard_summ + delivery_price ) : this.priceFormat( sum - giftcard_summ )} ₽</div>
                                  }
                                </div>
                                <div className='d-flex flex-column flex-sm-row align-items-center justify-content-between'>
                                  {order_sent ?
                                    <Button className={styles.korzina_rchast_btn + ` w-100`} variant='dark'>
                                      <div>Отправка заказа...</div>
                                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    </Button>
                                  :
                                    <Button onClick={() => this.sendOrder()} className={styles.korzina_rchast_btn + ` w-100`} variant='dark'>
                                      <div>Подтвердить заказ</div>
                                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.1727 15.5223C14.0633 15.5223 13.1639 16.4217 13.1639 17.5311C13.1639 18.6405 14.0633 19.5398 15.1727 19.5398C16.2821 19.5398 17.1815 18.6405 17.1815 17.5311C17.1815 16.4217 16.2821 15.5223 15.1727 15.5223ZM15.1727 15.5223H7.43286C6.96978 15.5223 6.73781 15.5223 6.54716 15.4399C6.37897 15.3672 6.23306 15.2502 6.12675 15.101C6.0076 14.9337 5.95967 14.7101 5.86481 14.2673L3.39277 2.73113C3.2957 2.27814 3.24651 2.05189 3.12598 1.8827C3.01967 1.73348 2.87379 1.61603 2.7056 1.54335C2.51491 1.46094 2.28423 1.46094 1.82096 1.46094H1.11133M4.12448 4.47409H17.0541C17.7791 4.47409 18.1412 4.47409 18.3845 4.6251C18.5976 4.75739 18.7536 4.96485 18.8217 5.20629C18.8993 5.48192 18.7995 5.82997 18.5986 6.5265L17.2079 11.3475C17.0878 11.764 17.0277 11.9718 16.9058 12.1264C16.7983 12.2628 16.6564 12.3695 16.4955 12.4351C16.3138 12.5091 16.0978 12.5091 15.6669 12.5091H5.86253M6.13324 19.5398C5.02383 19.5398 4.12448 18.6405 4.12448 17.5311C4.12448 16.4217 5.02383 15.5223 6.13324 15.5223C7.24265 15.5223 8.14201 16.4217 8.14201 17.5311C8.14201 18.6405 7.24265 19.5398 6.13324 19.5398Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    </Button>
                                  }

                                  <div className={styles.korzina_promocode_btn}>
                                    <input value={giftcard} onChange={( e ) => this.setGiftcard( e.target.value )} name="giftcard" type="text" placeholder="Подарочная карта" className={styles.korzina_promocode_input} />
                                    <svg onClick={() => this.sendGiftcard()} style={{ flex: `none`, cursor: `pointer` }} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect width="30" height="30" rx="15" fill="white"/>
                                      <path d="M22.5 15.0007L18.3333 10.834M22.5 15.0007L18.3333 19.1673M22.5 15.0007H7.5" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                  </div>
                                </div>
                              </>
                            }
                          </>
                        }
                      </div>
                      {loaded &&
                        <>
                          {loyalty.bonus != null &&
                            <div className={styles.loyalty_bonus_plashka}>
                              <div>Начислим бонусы на карту лояльности</div>
                              <div className={styles.loyalty_bonus_plashka_add}>{loyalty.bonus.will_add} {this.normalizeCountForm( loyalty.bonus.will_add, [ 'бонус', 'бонуса', 'бонусов' ] )}</div>
                            </div>
                          }
                        </>
                      }
                      <div className={styles.korzina_rchast_katalog}>
                        <div className={styles.korzina_rchast_pkonf + ` d-flex align-items-center justify-content-center w-100`}>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                          </svg>
                          <div>Я ознакомлен и согласен с условиями <a href={page_data.pconf_link}>оферты и политики конфиденциальности</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
        <Modal centered show={show} onHide={() => this.handleClose()}>
          <Modal.Header closeButton>
            <Modal.Title>{ajax_data.pagetitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal_text}</Modal.Body>
        </Modal>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool,
  addTocart: PropTypes.func,
  clearCart: PropTypes.func
}